import type { TContextualTab, TNavigationItem } from '~/src/types/navigation'
import {
  NAVIGATION_ITEMS,
  TOOLS_NAVIGATION_ITEMS,
} from '~/constants/navigation'

const getIsCurrent = (path: string, href?: string) => {
  if (!href) return false

  const splitHref = href.split('/').filter(Boolean)
  const hasTools = path.startsWith('/tools')

  if (hasTools) {
    const pathWithoutTools = path.replace('/tools', '')

    if (splitHref.length === 1) return path === href

    const market = `/${splitHref[1] ?? ''}`
    return pathWithoutTools.startsWith(market)
  }

  const market = `/${splitHref[0] ?? ''}`
  return path.startsWith(market)
}

const getNavigationTabs = (path: string, navigationItem: TNavigationItem) => {
  if (!navigationItem.tabs) return []
  return navigationItem.tabs.map((tab) => ({
    ...tab,
    current: path.startsWith(tab.href || ''),
  }))
}

const getNavigationItem = (path: string, navigationItem: TNavigationItem) => {
  if (!navigationItem.children) {
    return {
      ...navigationItem,
      current: getIsCurrent(path, navigationItem.href),
      tabs: getNavigationTabs(path, navigationItem),
    }
  }

  return {
    ...navigationItem,
    current: navigationItem.children.some((child) =>
      getIsCurrent(path, child.href),
    ),
    tabs: getNavigationTabs(path, navigationItem),
    children: navigationItem.children.map((child) =>
      getNavigationItem(path, child),
    ),
  }
}

export const getNavigation = (path: string): TNavigationItem[] => {
  const toolItems = TOOLS_NAVIGATION_ITEMS.filter(
    (item) => item.href !== '/price-dashboard/chart-builder',
  )
  const isToolPage = toolItems.some((item) => path.startsWith(item.href))

  const navigation = isToolPage ? TOOLS_NAVIGATION_ITEMS : NAVIGATION_ITEMS()
  return navigation.map((item) => getNavigationItem(path, item))
}

export const getCurrentTabs = (
  navigation: TNavigationItem[],
): TContextualTab[] => {
  const currentItem = navigation.find((item) => item.current)

  if (!currentItem) return []

  const hasChildren = currentItem.children?.length > 0

  if (!hasChildren) return currentItem.tabs || []

  const currentChild = currentItem.children?.find((child) => child.current)

  if (!currentChild) return []

  return currentChild.tabs || []
}
